







































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

import { appsApi } from '@/features/apps/shared/services/apps';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { PrivateApp, UpdatePrivateAppViewModel } from '@/features/apps/shared/models';
import Toast from '@/shared/services/toast';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';

const url = (value: string) => {
	if (!value) {
		return true;
	}
	return value.startsWith('http://') ||  value.startsWith('https://');
};

@Component({
	mixins: [validationMixin],
	validations: {
		app: {
			name: { required },
			workflowOptions: {
				configUrl: {url},
				initUrl: {url},
				submitUrl: {url},
				webhookUrl: {url}
			}
		}
	},
	beforeRouteEnter(to: any, from: any, next: any) {
		next((vm: EditPrivateApp) => {
			vm.$emit('loading');
		});
	}
})
export default class EditPrivateApp extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Action(HANDLE_SERIOUS_ERROR) public handleSeriousError: any;

	public actionInProgress: boolean = false;

	public app: PrivateApp = {
		id: '',
		name: '',
		ownerWorkspaceId: '',
		apiToken: '',
		capabilities: {
			supportsWebhooks: false,
			supportsBotAction: false,
			supportsHomescreen: false
		},
		workflowOptions: {
			configUrl: '',
			initUrl: '',
			submitUrl: '',
			webhookUrl: '',
			verificationToken: '',
			webhookTopics: []
		}
	};

	public supportsAppLifecycleHooks() {
		return this.app.capabilities.supportsHomescreen || this.app.capabilities.supportsBotAction;
	}

	public created() {
		if (!this.currentWorkspace) {
			this.handleSeriousError('No workspace selected');
			return;
		}

		appsApi.getPrivateApp(this.currentWorkspace.id, this.$route.params.id)
			.then(app => {
				this.app = app;
			}).catch(err => {
				this.handleSeriousError(err.message);
			}).finally(() => this.$emit('loaded'));
	}

	public onCopy() {
		Toast.showInfo('Copied to clipboard');
	}

	public save() {
		if (this.actionInProgress) {
			return;
		}

		this.actionInProgress = true;

		const request = {
			appName: this.app.name,
			capabilities: this.app.capabilities,
			workflowOptions: this.app.workflowOptions
		} as UpdatePrivateAppViewModel;

		appsApi.updatePrivateApp(this.currentWorkspace.id, this.app.id, request)
			.then(() => {
				Toast.showSuccess('App config saved');
				this.$router.push({ name: 'private-apps-list' });
			})
			.catch((err) => Toast.showError(err.message))
			.finally(() => this.actionInProgress = false);
	}

	public cancel() {
		this.$router.push({ name: 'private-apps-list' });
	}
}
